export function getUnits(count, value) {
  var units = [];
  var floatPart = value % 1;
  var intPart = Math.floor(value);
  for (var i = 0; i < count; i++) {
    var unitValue = i < intPart ? 1 : 0;
    if (intPart === i) {
      unitValue = floatPart;
    }
    units.push(unitValue);
  }
  return units;
}